import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import createToolbar from './toolbar/createToolbar.js';
import { DEFAULT_CONFIG } from './constants.js';
import { EMOJI_TYPE } from './types.js';
import { createEmojiDecorator } from './createEmojiDecorator.js';
import './toolbar/insert-buttons.js';
import 'wix-rich-content-editor-common';
import './toolbar/emojiInsertModal.js';
import 'react';
import './modifiers/addEmoji.js';
import './toolbar/emojiPreviewModal.js';
import 'prop-types';
import 'react-custom-scrollbars';
import 'wix-rich-content-common';
import './icons/JoyPixelsIcon.js';
import './utils/getGroupEmojis.js';
import './utils/convertUnicodeToEmoji.js';
import './utils/emojiList.js';
import 'wix-rich-content-ui-components';
import './icons/EmojiPluginIcon.js';
import './icons/FaBell.js';
import './icons/FaFlag.js';
import './icons/FaHeart.js';
import './icons/FaPaw.js';
import './icons/FaSmile.js';
import './icons/FaPlane.js';
import './icons/FaUtensils.js';
import './icons/FaRegFutbol.js';
import './emojiComponent.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createEmojiPlugin = (config) => {
  const type = EMOJI_TYPE;
  const _a = config, {
    helpers,
    theme,
    t,
    isMobile,
    [type]: settings = {},
    getEditorState,
    setEditorState
  } = _a, rest = __objRest(_a, [
    "helpers",
    "theme",
    "t",
    "isMobile",
    __restKey(type),
    "getEditorState",
    "setEditorState"
  ]);
  const toolbar = createToolbar({
    helpers,
    settings,
    isMobile,
    getEditorState,
    setEditorState,
    theme,
    t
  });
  return createBasePlugin(
    __spreadValues({
      settings,
      theme,
      type,
      toolbar,
      helpers,
      t,
      defaultPluginData: DEFAULT_CONFIG,
      isMobile,
      setEditorState,
      getEditorState
    }, rest),
    { decorators: createEmojiDecorator() }
  );
};
createEmojiPlugin.functionName = EMOJI_TYPE;

export { EMOJI_TYPE, createEmojiPlugin };
//# sourceMappingURL=createEmojiPlugin.js.map
